import once from "lodash/once";
import config from "../../config";

/**
 * Logs out the version and renderer information for this running instance of PlayUI.
 *
 */
export const hello = once(() => {
  if (!(window && window.console)) {
    return;
  }

  const str = `PlayUI | v${config.VERSION} | ${config.BUILD_DATE}`;
  const hr = "-".repeat(str.length);
  const hasFancyConsole = /chrome|firefox/i.test(
    navigator && navigator.userAgent.toLowerCase()
  );
  const simpleHello = () => {
    window.console.log(`${hr}\n${str}\n${hr}`);
  };

  if (hasFancyConsole) {
    const args = [
      `\n%c${str}%c\n\n`,
      "color: #6FBE1E; background: #030307; padding:5px",
      "padding:0"
    ];
    try {
      window.console.log.apply(window.console, args);
    } catch (e) {
      simpleHello();
    }
  } else if (window && window.console) {
    simpleHello();
  }
});
